
	import Vue from 'vue';
	import {Component, Prop} from 'vue-property-decorator';
	import {ISkin} from "@/models/ISkin";

	@Component
	export default class SkinChipLinkScmm extends Vue {

		@Prop({type: Object, required: true})
		public skin!: ISkin;

		@Prop({type: Boolean, default: false})
		public dense!: boolean;

		@Prop({type: Boolean, default: false})
		public small!: boolean;

		@Prop({type: Boolean, default: false})
		public xSmall!: boolean;

		@Prop({type: String, default: '#ce422b'})
		public color!: string;

		@Prop({type: Boolean, default: false})
		public dark!: boolean;

		private get label(): string {
			return this.dense ? 'S' : 'SCMM';
		}

		private openLink(): void {
			if (this.skin.scmm_url === null) return;
			window.open(this.skin.scmm_url, '_blank');
		}

	}
